const clickMenu = function (params) { //点击菜单
  sensors.track('web30_click_menu', params)
}
const search = function (params) { //搜索
  sensors.track('web30_search', params)
}
const clickSame = function (params) { //点击同靶点/同适应症
  sensors.track('h5chemistry_click_same', params)
}
const exportLoad = function (params) { //导出
  sensors.track('h5chemistry_export', params)
}
const slowRequestRecord= function(params) {//慢请求记录（针对服务端请求，当请求超过3s时采集）
  sensors.track('web30_slow_request_record', params);
}
const exceptionRequestRecord= function(params) {//异常请求记录（针对服务端请求，当请求发生异常时采集）
  sensors.track('web30_exception_request_record', params);
}
const exceptionRecord= function(params) {//异常请求记录（当前端发生异常时采集）
  sensors.track('web30_exception_record', params);
}
export {
  clickMenu,
  search,
  clickSame,
  exportLoad,
  slowRequestRecord,
  exceptionRequestRecord,
  exceptionRecord
}



// WEBPACK FOOTER //
// ./src/service/tracepoint.js